// @ts-nocheck
/**
 * Alert Mock Data - 100+ alerts
 */

import { generateAlerts } from './helpers';

// Generate 120 alerts with realistic distribution
export const mockAlerts = generateAlerts(120, {
  info: 0.35,
  warning: 0.35,
  error: 0.20,
  success: 0.10,
});

// Categorized alerts
export const mockSystemAlerts = mockAlerts.filter((a) => a.category === 'system');
export const mockSecurityAlerts = mockAlerts.filter((a) => a.category === 'security');
export const mockPerformanceAlerts = mockAlerts.filter((a) => a.category === 'performance');
export const mockBusinessAlerts = mockAlerts.filter((a) => a.category === 'business');

// Critical alerts only
export const mockCriticalAlerts = mockAlerts.filter((a) => a.severity === 'error');

// Recent alerts (last 24 hours)
export const mockRecentAlerts = mockAlerts.filter((a) => {
  const hoursSinceAlert = (new Date().getTime() - a.timestamp.getTime()) / (1000 * 60 * 60);
  return hoursSinceAlert < 24;
});
